module.exports = __webpack_public_path__ + "assets/left-arrow-2.636ce400.svg";